import React from 'react'

import Paper from '@material-ui/core/Paper'
import Text from '@material-ui/core/Typography'

function Summary() {
	return (
		<Paper style={{ padding: 20, minHeight:800 }} >
			<Text variant='h5' gutterBottom>
				Summary
			</Text>
			<Text variant='caption' gutterBottom>
				Summary of Organization Account<br/>
				 - Funds in Account<br/>
				 - Funds Available<br/>
				 - Funds Outstanding by team members<br/>
				 - REQUEST A WITHDRAWL
			</Text>
		</Paper>
	)
}
export default Summary
